import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ProductsLearnMoreModal from "./ProductsLearnMoreModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

export default function ProductsMonitoringAndAlerting() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleLearnMoreClick = (event, product) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="bg-page rounded-4 p-3 mb-5">
      <div className="text-center mb-4">
        <img
          src="/assets/products/images/monalert.png"
          alt="Monitoring and Alerting"
          className="img-fluid rounded-4"
          style={{ maxHeight: "280px", objectFit: "cover" }}
        />
        <div className="fw-bold text-navy text-center fs-2 mt-3">
          Monitoring and Alerting
        </div>
      </div>

      <div>
        <p className="fs-5 mt-3">
          It is becoming increasingly hard to filter the wheat from the chaff in
          connected environments, and when you do, the software managing it is
          either woefully lacking in the tools it provides to manage the
          notifications or can often be overkill with a level of complexity and
          cost that causes its own problems.
        </p>
        <p className="fs-5 ">
          Boomerang has approached this in the most efficient way possible,
          empowering its customers to connect to, interpret, escalate and
          control the notifications that come from networks, network-connected
          devices, machines and monitors, checking the failure and escalating to
          a predefined process of communication, management and control.
        </p>
        <p className="fs-5 ">
          Managed through Boomlogic’s mapping software, each event is visible,
          can communicate with affected assets, contracts, and groups, update in
          real time, issue tickets, and intercede to enable manual management of
          the event. It can even run the Service Level communications to your
          customers.
        </p>
        <p className="fs-5 ">
          We have achieved this by focusing on communications and working
          backwards, resulting in a complete and effective capability at a
          surprisingly low cost.
        </p>
        <p className="fs-5 ">Come give us a go.</p>
      </div>

      <div className="text-center d-flex justify-content-center gap-3 mt-4">
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "trial" })}
        >
          Free trial
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "buy" })}
        >
          Buy
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) =>
            handleLearnMoreClick(event, { name: "more information" })
          }
        >
          More Information
        </Button>
        <ProductsLearnMoreModal
          selectedProduct={selectedProduct}
          handleCloseModal={handleCloseModal}
        />
      </div>
    </div>
  );
}
